import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllCouponHistory } from "../../../../features/admin/master/coupon_history/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const coupon = useSelector((state) => state.masters.coupon_history);

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = coupon?.current_page) => {
    // await dispatch(Allcoupon());
    await dispatch(
      GetAllCouponHistory({
        name: name,
        page: page,
        per_page: coupon?.per_page,
      }),
    );
  };

  return {
    coupon,
    name,
    setName,
    fetch,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
